import EventEmitter from "events";

export default class ScrollListener extends EventEmitter {

    constructor(options) {
        super();
        this.lastViewportUpdate = performance.now();
        this.isProcessingScroll = !1;
        this.scene = $(options.scene);
        this.scroller = $(options.scroller);
        this.offset = 0;
        this.destroyed = false;
        this.animationFrame = null;
        this.getOffset = options.getOffset;

        this.onScroll = this._onScroll.bind(this);

        this.scroller.on("scroll", this.onScroll);

        this.updateOffset(options.scrollerHeight, options.scale);

        this._notify();
    }

    updateOffset(scrollerHeight, scale = 1) {
        this.offset = (this.scene[0].offsetTop || 0) * scale;
        this.scrollerHeight = scrollerHeight;
    }

    _notify() {
        let top = Math.round(this.scroller.scrollTop()) - (this.getOffset ? this.getOffset() : this.offset),
            bottom = top + this.scrollerHeight
        ;

        this.emit('scrolled', {target: this.scene, data: {top: top, bottom: bottom}});
    }

    _onScroll(event) {
        if (this.destroyed || this.isProcessingScroll) return;
        this.isProcessingScroll = true;
        this.animationFrame = requestAnimationFrame(e => this._processScroll(e));
    }

    _processScroll(e) {
        this.animationFrame = null;
        if (this.destroyed) return;
        if (e - this.lastViewportUpdate > 10) {
            this._notify();
            this.lastViewportUpdate = e;
            this.isProcessingScroll = !1;
        } else {
            this.animationFrame = requestAnimationFrame(e => this._processScroll(e));
        }
    }

    destroy() {
        this.destroyed = true;
        if (this.animationFrame !== null) cancelAnimationFrame(this.animationFrame);
        this.animationFrame = null;
        this.scroller.off("scroll", this.onScroll);
        // $(window).off(CONSTANTS.EVENT_AFTER_RESIZE, this.onResize);
        return this;
    }

}
